export default __webpack_public_path__ + "static/media/add_to_github_white.29274476.png";